/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, memo } from 'react'
import {
  View,
  ScrollView,
  TouchableOpacity,
  StatusBar,
  Platform,
  Animated,
} from 'react-native'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
// import MapView, {
//   AnimatedRegion,
//   Marker,
//   PROVIDER_GOOGLE,
// } from 'react-native-maps'
import Geolocation from '@react-native-community/geolocation'
import {
  check,
  request,
  PERMISSIONS,
  RESULTS,
  openSettings,
} from 'react-native-permissions'
import PropTypes from 'prop-types'
import { Icon, VFInput } from '@vfgroup-oneplatform/foundation/Components'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import { lowerCase } from 'lodash'
import axios from 'axios'

import VfText from '../../Components/VfText'
import VFButton from '../../Components/VFButton'
// import VFInput from '../../Components/VFInput'
import Modal from '../../Components/Modal'
import Browser, { PermissionsModal } from '../../Components/Browser'

import images from '../../Themes/Images'
import styles from './GigaBonus.Styles'

const API_KEY = 'AIzaSyD58JOMBoL4V-Eg7GnnylkCJ38J1e7_V_w'
const ADDRESS_TYPES = ['locality', 'administrative_area_level_1']
const INITIAL_REGION = {
  latitude: 41.3275,
  longitude: 19.8187,
  latitudeDelta: 0.015,
  longitudeDelta: 0.0121,
}
const MODAL_ICONS = {
  success: images.tick,
  error: images.error,
}

const DEFAULT_ERROR = {
  icon: images.error,
  title: 'giga_bonus_error',
  message: 'giga_bonus_error_message',
}
const ERRORS = {
  410: {
    icon: images.error,
    title: 'giga_bonus_error_410',
    message: 'giga_bonus_error_message_410',
  },
  411: {
    icon: images.tick,
    title: 'giga_bonus_error_411',
    message: 'giga_bonus_error_message_411',
  },
  412: {
    icon: images.error,
    title: 'giga_bonus_error_412',
    message: 'giga_bonus_error_message_412',
  },
}
const LOCATION_ERRORS = {
  PERMISSION_DENIED: 'giga_bonus_error_permission_denied',
  POSITION_UNAVAILABLE: 'giga_bonus_error_position_unavailable',
  TIMEOUT: 'giga_bonus_error_location_timeout',
}
const DEFAULT_LOCATION_ERROR = 'giga_bonus_error_position_unavailable'

const LocationSelector = memo(function Maps({ updateCoordinates }) {
  const [isMnualPermission, setMnualPermission] = useState(false)
  const [locationError, setLocationError] = useState({
    isVisible: false,
    message: '',
  })
  const region = useRef(INITIAL_REGION)
  const location = useRef(new AnimatedRegion(INITIAL_REGION)).current
  const opacity = useRef(new Animated.Value(0)).current

  const marker = useRef()
  const map = useRef()

  const animate = nextProps => {
    Animated.spring(opacity, { toValue: 1 }).start()
    location.timing({ ...nextProps, duration: 300 }).start()
    map.current?.animateToRegion({ ...nextProps })
  }

  const onMapPress = ({ nativeEvent: { coordinate } }) => {
    updateCoordinates(coordinate)
    animate({ ...region.current, ...coordinate })
  }

  const onMarkerDragEnd = ({ nativeEvent: { coordinate } }) => {
    updateCoordinates(coordinate)
    Animated.spring(opacity, { toValue: 1 }).start()
    const newCoordinates = { ...region.current, ...coordinate }
    location.setValue(newCoordinates)
    map.current?.animateToRegion(newCoordinates)
  }

  const onRegionChangeComplete = newRegion => {
    region.current = newRegion
  }

  const locate = () => {
    Geolocation.getCurrentPosition(
      ({ coords }) => {
        setLocationError({
          isVisible: false,
          message: '',
        })
        updateCoordinates(coords)
        animate({ ...region.current, ...coords })
      },
      (e) => {
        const error = Object.keys(e).find(item => e[item] === e.code && item !== 'code')
        setLocationError({
          isVisible: true,
          message: LOCATION_ERRORS[error] || DEFAULT_LOCATION_ERROR,
        })
      }
    )
  }

  const getCurrentLocation = () => {
    if (Platform.OS === 'ios') {
      Geolocation.requestAuthorization()
      locate()
    } else {
      check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION)
        .then(result => {
          switch (result) {
            case RESULTS.UNAVAILABLE:
              break
            case RESULTS.DENIED:
              request(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION)
                .then(res => {
                  if (res === RESULTS.GRANTED) {
                    locate()
                  }
                })
                .catch(() => { })
              break
            case RESULTS.GRANTED:
              locate()
              break
            case RESULTS.BLOCKED:
              setMnualPermission(true)
              break
          }
        })
        .catch(() => { })
    }
  }

  return (
    <>
      <View style={styles.mylocationContainer}>
        <View style={styles.mapContainer}>
          <MapView
            ref={ref => {
              map.current = ref
            }}
            provider={PROVIDER_GOOGLE}
            style={styles.map}
            initialRegion={INITIAL_REGION}
            onPress={onMapPress}
            onMarkerDragEnd={onMarkerDragEnd}
            onRegionChangeComplete={onRegionChangeComplete}
            mapPadding={{ top: 50 }}>
            <Marker.Animated
              ref={ref => {
                marker.current = ref
              }}
              coordinate={location}
              // icon={images.myHome}
              anchor={{ x: 0.5, y: 0.925 }}
              opacity={opacity}
              draggable
            >
              <Icon name={images.myHome} type="image" size={80} resizeMode="contain" />
            </Marker.Animated>
          </MapView>
        </View>
        <TouchableOpacity
          onPress={getCurrentLocation}
          style={styles.currentLocationButton}>
          <VfText
            i18nKey="giga_bonus_use_my_location"
            color={Colors.vfRed}
            align="center"
            style={styles.currentLocationText}
          />
        </TouchableOpacity>
      </View>
      {locationError.isVisible && <View style={styles.locationError}>
        {/* <Icon name={images.attention} type="image" size={24} resizeMode="contain" /> */}
        <VfText
          i18nKey={locationError.message}
          color={Colors.vfRed}
          align="center"
          style={styles.currentLocationText}
        />
      </View>}
      <PermissionsModal
        isVisible={isMnualPermission}
        onClose={() => setMnualPermission(false)}
        close={() => setMnualPermission(false)}
        onOpenSettings={() => {
          setMnualPermission(false)
          openSettings()
        }}
      />
    </>
  )
})
LocationSelector.defaultProps = {
  updateCoordinates: () => { },
}
LocationSelector.propTypes = {
  updateCoordinates: PropTypes.func,
}

function GigaBonus({
  orderBonus,
  name,
  nameRegex,
  setName,
  setCity,
  coordinates,
  setCoordinates,
  navigation: { goBack },
  route
}) {
  const insets = useSafeAreaInsets()
  const title = route.params.title || {}
  const data = route.params.item || {}

  const [loading, setLoading] = useState(false)
  const [isDetailsVisible, setDetailsVisibility] = useState(false)
  const [isNameError, setNameError] = useState(false)
  const checkNameError = () => {
    if (nameRegex) {
      if (name && !nameRegex.test(name)) {
        setNameError(true)
      }
    }
  }

  const changeStatusBar = (
    barStyle = 'light-content',
    backgroundColor = Colors.transparent,
    translucent = true,
  ) => {
    StatusBar.setBarStyle(barStyle, true)
    if (Platform.OS === 'android') {
      StatusBar.setBackgroundColor(backgroundColor, true)
      StatusBar.setTranslucent(translucent)
    }
  }

  const [browserState, setBrowserState] = useState({
    isVisible: false,
    url: '',
  })
  const openBrowser = (urlKey, contentManager = true, placeholders = []) => {
    const url = contentManager
      ? ContentManager.translate(urlKey, placeholders)
      : urlKey
    changeStatusBar('dark-content', Colors.whiteSmoke)
    setBrowserState({
      isVisible: true,
      url: url,
    })
  }
  const closeBrowser = () => {
    setBrowserState({
      isVisible: false,
      url: '',
    })
    changeStatusBar('light-content', Colors.transparent)
  }

  const [modal, setModal] = useState({
    isVisible: false,
    icon: undefined,
    title: '',
    desc: '',
    actionTitle: 'giga_bonus_go_back',
    action: () => { },
    onHide: () => { },
    dismissable: true,
  })

  const dismissModal = (onHide = () => { }) => {
    setModal({
      isVisible: false,
      icon: undefined,
      title: '',
      desc: '',
      actionTitle: '',
      action: () => { },
      onHide,
      dismissable: true,
    })
    changeStatusBar('light-content', Colors.transparent)
  }

  const displayModal = ({
    isVisible = true,
    icon = undefined,
    title: modalTitle = '',
    desc = '',
    actionTitle = 'giga_bonus_go_back',
    action = () => dismissModal(),
    onHide = () => { },
    dismissable = true,
  }) => {
    changeStatusBar('dark-content', Colors.white)
    setModal({
      isVisible,
      icon,
      title: modalTitle,
      desc,
      actionTitle,
      action,
      onHide,
      dismissable,
    })
  }

  const updateCity = () => {
    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates}&key=+${API_KEY}`,
      )
      .then(res => {
        const result = res.data.results[0].address_components || []
        const cityName = result
          .find(element => ADDRESS_TYPES.includes(element.types[0]))
          ?.long_name?.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .normalize('NFC')
        setCity(cityName)
      })
      .catch(() => { })
  }
  const updateCoordinates = latlng => {
    const { latitude, longitude } = latlng
    setCoordinates(latitude + ',' + longitude)
  }

  useEffect(() => {
    if (coordinates) {
      updateCity()
    }
  }, [coordinates])

  useEffect(() => {
    if (data.gigafamily === 'false') {
      const error = ERRORS[410]
      displayModal({
        icon: MODAL_ICONS.error,
        title: error.title,
        desc: error.message,
        actionTitle: 'giga_bonus_go_back',
        action: () => {
          dismissModal()
          goBack()
        },
        onHide: () => { },
        dismissable: false,
      })
    }
  }, [])

  return (
    <View style={styles.screenWrapper}>
      <StatusBar
        translucent
        barStyle="light-content"
        backgroundColor={Colors.transparent}
        animated
      />
      <View style={styles.headerBackground(insets.top)} />
      <SafeAreaView style={styles.container} edges={['top', 'right', 'left']}>
        <View style={styles.headerWrapper}>
          <View style={styles.header}>
            <View style={styles.headerContentWrapper}>
              <View style={styles.empty} />
              {lowerCase(title) === 'giga family' ? (
                <Icon
                  name={images.GFLogo}
                  type="image"
                  width={120}
                  height={40}
                  resizeMode="contain"
                />
              ) : (
                <VfText i18nKey={title || ''} size="h5" color={Colors.white} />
              )}
              <TouchableOpacity onPress={() => goBack()}>
                <Icon
                  name={images.close}
                  type="image"
                  resizeMode="contain"
                  size={24}
                  style={styles.closeIcon}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={styles.scrollContainer}
          contentContainerStyle={styles.scrollContentContainer(insets.bottom)}>
          <View style={styles.titleContainer}>
            <VfText
              i18nKey={data.desc || 'giga_bonus_title'}
              weight="bold"
              size="h3"
              style={styles.title}
            />
            <TouchableOpacity
              onPress={() => setDetailsVisibility(true)}
              style={styles.infoIconContainer}>
              <Icon
                name={images.info}
                type="image"
                size={24}
                resizeMode="contain"
                style={styles.infoIcon}
              />
            </TouchableOpacity>
          </View>
          <VfText i18nKey="giga_bonus_helper_text" style={styles.desc} />
          <View style={styles.sectionHeaderContainer}>
            <Icon
              name={images.user}
              type="image"
              size={32}
              resizeMode="contain"
            />
            <View style={styles.sectionHeaderDetails}>
              <VfText i18nKey="giga_bonus_section_title" size="footnote" />
              <VfText
                i18nKey="giga_bonus_section_data_title"
                weight="bold"
                size="h5"
              />
            </View>
          </View>
          <VFInput
            label="giga_bonus_label_name"
            value={name}
            onChangeText={setName}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText}
            style={styles.inputText}
            tintColor={Colors.ocean}
            onBlur={checkNameError}
            onFocus={() => setNameError(false)}
            showHelperText={isNameError}
            helperTextColor={Colors.red}
            helperText="giga_bonus_helper_text_name"
          />
          {/* <LocationSelector updateCoordinates={updateCoordinates} /> */}
          <VFButton
            type="primary"
            title="giga_bonus_send"
            onPress={() => {
              setLoading(true)
              orderBonus({
                onSuccess: () => {
                  displayModal({
                    icon: MODAL_ICONS.success,
                    title: 'giga_bonus_success',
                    desc: 'giga_bonus_success_message',
                    action: () => dismissModal(),
                  })
                  setLoading(false)
                },
                onError: e => {
                  let error,
                    errorObj = {}
                  if (Object.keys(ERRORS).includes(e.error_code)) {
                    error = ERRORS[e.error_code]
                  } else {
                    error = DEFAULT_ERROR
                  }
                  errorObj = {
                    icon: error.icon,
                    title: error.title,
                    desc: e.message || error.message,
                    actionTitle: 'giga_bonus_get_help',
                    action: () =>
                      dismissModal(() => openBrowser('giga_bonus_help_url')),
                  }
                  if (e.error_code === '411') {
                    errorObj = {
                      ...errorObj,
                      actionTitle: 'giga_bonus_go_back',
                      action: () => dismissModal(),
                    }
                  }
                  displayModal(errorObj)
                  setLoading(false)
                },
              })
            }}
            style={styles.confirmButton}
            disabled={loading || !name || !coordinates || isNameError}
            isLoading={loading}
            loadingTitle="Processing..."
          />
        </ScrollView>
        <Modal
          visible={modal.isVisible}
          close={modal.dismissable ? () => dismissModal() : undefined}
          onModalHide={() => modal.onHide()}
          contentContainerStyle={styles.modal}
          type="full">
          <View style={styles.modalHeader(insets.top)}>
            {modal.dismissable && (
              <TouchableOpacity onPress={() => dismissModal()}>
                <Icon
                  name={images.close}
                  type="image"
                  size={24}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            )}
          </View>
          <View style={styles.modalContentContainerWraper(insets.bottom)}>
            <View style={styles.modalContentWraper}>
              <Icon
                name={modal.icon}
                size={120}
                type="image"
                resizeMode="contain"
              />
              <View>
                <VfText
                  weight="bold"
                  size="h3"
                  align="center"
                  style={styles.verticalSpacing}
                  i18nKey={modal.title}
                />
                <VfText align="center" i18nKey={modal.desc} />
              </View>
            </View>
            <VFButton
              type="primary"
              title={modal.actionTitle}
              onPress={() => modal.action?.()}
              style={styles.lastModalButton}
            />
          </View>
        </Modal>
        <Browser browserState={browserState} closeBrowser={closeBrowser} />
        <Modal
          visible={isDetailsVisible}
          close={() => setDetailsVisibility(false)}>
          <View style={styles.detailsHeader}>
            <VfText i18nKey="giga_bonus_details_title" weight="bold" />
            <TouchableOpacity onPress={() => setDetailsVisibility(false)}>
              <Icon
                name={images.close}
                type="image"
                size={24}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
          <View style={styles.modalContent(insets.bottom)}>
            <VfText i18nKey="giga_bonus_details_section_1" />
            <VfText i18nKey="giga_bonus_details_section_2" weight="bold" />
            <View style={styles.detailsItem}>
              <VfText
                i18nKey="·"
                size="h2"
                weight="bold"
                style={styles.itemDot}
              />
              <VfText i18nKey="giga_bonus_details_item_1" style={styles.item} />
            </View>
            <View style={styles.detailsItem}>
              <VfText
                i18nKey="·"
                size="h2"
                weight="bold"
                style={styles.itemDot}
              />
              <VfText i18nKey="giga_bonus_details_item_2" style={styles.item} />
            </View>
            <View style={styles.detailsItem}>
              <VfText
                i18nKey="·"
                size="h2"
                weight="bold"
                style={styles.itemDot}
              />
              <VfText i18nKey="giga_bonus_details_item_3" style={styles.item} />
            </View>
            <View style={styles.detailsItem}>
              <VfText
                i18nKey="·"
                size="h2"
                weight="bold"
                style={styles.itemDot}
              />
              <VfText i18nKey="giga_bonus_details_item_4" style={styles.item} />
            </View>
            <View style={styles.detailsItem}>
              <VfText
                i18nKey="·"
                size="h2"
                weight="bold"
                style={styles.itemDot}
              />
              <VfText i18nKey="giga_bonus_details_item_5" style={styles.item} />
            </View>
          </View>
        </Modal>
      </SafeAreaView>
    </View>
  )
}

GigaBonus.defaultProps = {}

GigaBonus.propTypes = {
  orderBonus: PropTypes.func,
  name: PropTypes.string,
  nameRegex: PropTypes.string,
  setName: PropTypes.func,
  setCity: PropTypes.func,
  coordinates: PropTypes.string,
  setCoordinates: PropTypes.func,
  navigation: PropTypes.object,
  route: PropTypes.object,
}

export default GigaBonus
